import styled, {css} from 'styled-components'

export const StyledHomeCard = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 6}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        align-items: flex-start;
        border: 1px solid ${palette.neutral['200']};
        border-radius: 12px;
    `
)
